
// Languages for the entire App
// Note that different games may support different languages
export const languages = [
    { short: "en", full: "English" },
    { short: "ru", full: "русский" },
]

export const uiStrings = {
    'select_game': 
    {   
        en: 'Select a game...',
        ru: 'Выберите игру...',
    },
}